/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable react/jsx-no-bind */
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Layout, Table, Input,
} from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { IUser } from '../../../store/modules/user/i-user';
import { USER_CREATION_PATH, USER_DETAILS_PATH } from '../../routing/paths.constants';
import PageTitle from '../../lib/page-title';
import useGetUsers from './use-getUsers';
import './user-management.less';
import { IFormFields } from '../../lib/field-edit-form/field-edit-form';
import FilterSelect from '../../lib/filter-select';
import PrimaryButton from '../../lib/primary-button';
import SecondaryButton from '../../lib/secondary-button';
import PermissionProvider from '../../providers/permissionProvider';
import checkPermission from '../../../utils/permissions/permissions';

const UserManagement = (): JSX.Element => {
  const { users, onSearch } = useGetUsers();

  const { push } = useHistory();
  const [currentFilter, setCurrentFilter] = useState<string>('');
  const [searchValue, setSearchValue] = useState<string>('');

  const goToCreation = () => {
    push(USER_CREATION_PATH);
  };

  const handleChange = (e: string) => {
    setCurrentFilter(e);
    onSearch(searchValue, e);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
    onSearch(e.target.value, currentFilter);
  };
  const columns = [
    {
      title: 'Name',
      key: 'name',
      dataIndex: 'name',
      sorter: (a: IUser, b: IUser) => a.name.length - b.name.length,
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      sorter: (a: IUser, b: IUser) => a.role_id - b.role_id,
    },
    {
      title: 'Tenant',
      dataIndex: 'tenant',
      key: 'tenant',
      sorter: (a: IUser, b: IUser) => a.tenant.length - b.tenant.length,
    },
    {
      title: 'Email',
      key: 'email',
      dataIndex: 'email',
      sorter: (a: IUser, b: IUser) => a.email.length - b.email.length,
    },
    {
      title: '',
      key: 'details',
      dataIndex: 'details',
      // eslint-disable-next-line react/display-name
      render: (text: string, record: IUser) => (
        <SecondaryButton
          type="button"
          className="button-edit ant-btn--small"
          onClick={() => {
            push(`${USER_DETAILS_PATH}/${record.id}`);
          }}
        >
          details
        </SecondaryButton>
      ),
    },
  ];

  const data: Array<IFormFields> = [
    { name: 'Username', value: 'name' },
    { name: 'Role', value: 'role' },
    { name: 'Email', value: 'email' },
  ];
  const hasNotWritePermission = !checkPermission('users', 'write');
  return (
    <Layout className="main-container">
      <PermissionProvider pageId="users">
        <PageTitle title="Users">
          <PrimaryButton title="New User" onClick={goToCreation} disabled={hasNotWritePermission} />
        </PageTitle>
        <div className="users__filters">
          <FilterSelect
            currentFilter={currentFilter}
            onChange={(e) => handleChange(e)}
            data={data}
          />
          <Input
            className="search"
            placeholder="Keyword"
            onChange={onChange}
            suffix={<SearchOutlined style={{ color: '#D0D3D9' }} />}
          />
        </div>
        <Table
          className="table"
          style={{ height: 'auto' }}
          columns={columns}
          dataSource={users.data}
          rowKey={(record) => record.id}
          bordered={false}
          pagination={false}
          loading={users.loading}
        />
      </PermissionProvider>
    </Layout>
  );
};

UserManagement.displayName = 'UserManagement';

export default UserManagement;
